import {
  ICheckbox,
  IColorPicker,
  IDatePicker,
  IFile,
  IFormDocument,
  IInput,
  IOTP,
  IPassword,
} from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { TypedControlBase } from '../typed-controls';

export interface PasswordControlWithValue extends TypedControlBase {
  readonly control: IPassword;
  readonly type: 'password';
  value: string;
}

/**
 * Check that input control meta is password meta
 *
 * @param control - control metadata
 */
export function isPasswordControl(
  control:
    | ICheckbox
    | IColorPicker
    | IDatePicker
    | IFile
    | IInput
    | IOTP
    | IPassword,
): control is IPassword {
  return control.$type === 'password';
}

/**
 * Map control metadata to typed object with value from doc state
 *
 * @param control - control metadata
 * @param doc - doc
 */
export function getTypeControlForPassword(
  control: IPassword,
  doc: IFormDocument,
): PasswordControlWithValue {
  return {
    value: DocHelper.getStringValue(control.$name, doc),
    control,
    type: 'password',
  } as PasswordControlWithValue;
}
